import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { subsidiesParams, subsidyType } from "../types/subsidies.types";

@Injectable()
export class SubsidiesService {
  constructor(private http: HttpClientService) {}

  public getSubsidy(id: number): Observable<any> {
    return this.http.get(`/api/subsidies/${id}`).pipe(tap((_) => console.log("SubsidiesService.getSubsidy: Ok.")));
  }
  public getSubsidies(params: subsidiesParams): Observable<any> {
    return this.http
      .get("/api/subsidies", {
        params,
      })
      .pipe(
        map((response) => ({
          ...response,
          subsidies: response.subsidies.map((subsidy) => ({
            ...subsidy,
            status_color: this.getStatusColor(subsidy.status),
            out_of_date_color: this.getOutOfDateColor(subsidy.out_of_date),
          })),
        })),
        tap(() => console.debug("SubsidiesService.getSubsidies: Ok."))
      );
  }

  public createSubsidy(data): Observable<any> {
    return this.http.post("/api/subsidies", data).pipe(tap((_) => console.log("SubsidiesService.createSubsidy: Ok.")));
  }

  public updateSubsidy(data): Observable<any> {
    return this.http
      .put(`/api/subsidies/${data.id}`, data)
      .pipe(tap((_) => console.log("SubsidiesService.updateSubsidy: Ok.")));
  }

  public deleteSubsidy(id): Observable<any> {
    return this.http
      .delete(`/api/subsidies/${id}`)
      .pipe(tap((_) => console.log("SubsidiesService.deleteSubsidy: Ok.")));
  }

  public updateStatuses(subsidies: any[], status: string) {
    return this.http
      .put("/api/subsidies/change_status", { subsidies, status })
      .pipe(tap((_) => console.log("SubsidiesService.updateStatuses: Ok.")));
  }

  private getStatusColor(status: string): string {
    const statusColors: Record<string, string> = {
      unverified: "danger",
      verified: "success",
      rejected: "warning",
    };
    return statusColors[status] || "secondary"; // Default color
  }

  private getOutOfDateColor(out_of_date: string): string {
    const outOfDateColors: Record<string, string> = {
      true: "danger",
      false: "success",
    };
    return outOfDateColors[out_of_date] || "secondary"; // Default color
  }

  public getSubsidyTypes(): Observable<subsidyType[]> {
    return this.http.get("/api/subsidies/types").pipe(tap((_) => console.log("SubsidiesService.getSubsidyTypes: Ok.")));
  }

  public validateSubsidies(data: any): Observable<any> {
    return this.http
      .post("/api/subsidies/validate", data)
      .pipe(tap((_) => console.log("SubsidiesService.validateSubsidies: Ok.")));
  }

  public createBulkSubsidies(data: any): Observable<any> {
    return this.http
      .post("/api/subsidies/bulk_create", data)
      .pipe(tap((_) => console.log("SubsidiesService.createBulkSubsidies: Ok.")));
  }
}
